import script from "./2_PayPlan.vue?vue&type=script&setup=true&lang=ts"
export * from "./2_PayPlan.vue?vue&type=script&setup=true&lang=ts"

import "./2_PayPlan.vue?vue&type=style&index=0&id=74b97dac&lang=css"

const __exports__ = script;

export default __exports__